export function getAssetPath (relativePath)  {
    const baseUrl = process.env.REACT_APP_BASE_URL || '';
    return `/${relativePath}`;
  };

